import Card1 from "./Card1";
import Card2 from "./Card2";
import Card3 from "./Card3";
import Card4 from "./Card4";

const CardSwitcher = ({ data }) => {
  const theme = data.theme?.toString() || "1"; // varsayılan tema 1

  console.log("theme="+ theme)

  switch (theme) {
    case "4":
      return <Card4 data={data} />;
    case "2":
      return <Card2 data={data} />;
    case "3":
      return <Card3 data={data} />;
    case "1":
    default:
      return <Card1 data={data} />;
  }
};

export default CardSwitcher;
